import React from 'react';

interface Props {
	size: number;
}

export const ScienceMathIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>scienceMath</title>
		<path d='M11.63 23.67c-2.38 0-4.35-4.22-4.66-10v-1.63-.8-.45C7.2 4.71 9.17.33 11.63.33c2.64 0 4.71 5.13 4.71 11.67s-2.07 11.67-4.71 11.67zm0-22.49c-1.89 0-3.63 4.31-3.83 9.6V12c0 .54 0 1.07.05 1.59.28 5.17 1.95 9.23 3.81 9.23s3.83-4.35 3.83-10.82-2-10.82-3.86-10.82z' />
		<path d='M4.7 19.15c-1.53 0-2.66-.43-3.17-1.31-.67-1.16-.18-2.84 1.37-4.76a23.65 23.65 0 016.38-5.16c5.66-3.27 11.14-4 12.46-1.76s-2.09 6.65-7.74 9.92c-3.48 2-6.88 3.07-9.3 3.07zM18.57 5.68c-2.12 0-5.32.93-8.87 3a22.55 22.55 0 00-6.14 5c-1.3 1.59-1.77 3-1.3 3.79.93 1.53 5.74 1.11 11.3-2.13S21.93 8.2 21 6.59c-.34-.59-1.2-.91-2.43-.91z' />
		<path d='M18.56 19.15c-2.41 0-5.81-1.07-9.28-3.07a23.65 23.65 0 01-6.38-5.16C1.35 9 .86 7.32 1.53 6.16 2.84 3.88 8.32 4.65 14 7.92s9.07 7.63 7.75 9.92c-.52.88-1.66 1.31-3.19 1.31zM4.69 5.68c-1.23 0-2.09.32-2.43.91-.47.82 0 2.2 1.3 3.79a22.55 22.55 0 006.14 5c5.61 3.2 10.37 3.62 11.3 2.03s-1.83-5.52-7.44-8.75C10 6.61 6.81 5.68 4.69 5.68z' />
		<circle cx='11.63' cy='12' r='1.07' />
		<path d='M11.63 13.5a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zm0-2.15a.65.65 0 10.65.65.65.65 0 00-.65-.65z' />
		<circle cx='9.49' cy='21.64' r='1.07' />
		<path d='M9.49 23.14a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zm0-2.15a.65.65 0 10.65.65.65.65 0 00-.65-.64z' />
		<circle cx='21.27' cy='8.25' r='1.07' />
		<path d='M21.27 9.75a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zm0-2.14a.64.64 0 00-.65.64.65.65 0 101.3 0 .64.64 0 00-.65-.64z' />
	</svg>
);
